export default __webpack_public_path__ + "static/media/icon-master-data.d2f1d493.svg";